import type { PopupState } from './_state.type';

/** Popup State. */
export const popupState: PopupState = {
  messages: [],
  sessionId: null,
  conversations: null,
  isOpen: false,
  summaryMessage: null,
  summaryDocumentId: undefined,
  isSummaryProcessing: false,
  isProcessing: false,
};
